export function Icon({ icon: IconComponent, size, color }: { icon: any; size: string; color?: string }) {
  return <IconComponent style={{ width: size, height: size, color: color, display: 'block' }} />;
}
